import { createRouter, createWebHashHistory } from 'vue-router'
import AboutView from '../views/ErrorView.vue'
import SuccessView from '../views/SuccessView.vue'
import recordView from '../views/RecordView.vue'
import Box from '../views/BoxView.vue'
import bindView from '../views/BindView.vue'
import HomeView from '../views/HomeView.vue'
import WalletView from '../views/WalletView.vue'
import LessonView from '../views/LessonView.vue'
import LessonInfoView from '../views/LessonInfoView.vue'

const routes = [
  {
    path: '/lessoninfo',
    name: 'lessoninfo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: LessonInfoView
  },
  {
    path: '/lesson',
    name: 'lesson',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: LessonView
  },
  {
    path: '/error',
    name: 'error',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutView
  },
  {
    path: '/success',
    name: 'success',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: SuccessView
  },
  {
    path: '/record',
    name: 'record',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: recordView
  },
  {
    path: '/bind',
    name: 'bind',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: bindView
  },
  {
    path: '/',
    name: 'box',
    component: Box
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: WalletView
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: HomeView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
// const router = createRouter({
//   history: createWebHistory(), // 使用 History 模式
//   // history: createWebHistory('/box/'), // 使用 History 模式
//   routes
// })

export default router
